import React, { useState } from "react";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";

import "../../css/createSourceModal.css";
import {
    getPipedriveUrl,
    sendDataPipedrive,
} from "../../helpers/Sources/pipedrive/pipedriveSource";
import CrmSourceMappingArea from "../CrmSourceMappingArea";
import LoginButton from "../molecules/LoginButton";
import SwalAlertComp from "../SwalAlert";

const PIPEDRIVE_LOGO = "/assets/images/typeImages/pipedrive.png";

const PipedriveSource = (props) => {
    const { useHostFooter = false, registerFooterAction } = props;
    const language = useSelector((state) => state.languagesState.languages);
    const [pipedriveName, setPipedriveName] = useState("");
    const [pipedriveBtn, setPipedriveBtn] = useState(false);
    const [pipedriveCheck, setPipedriveCheck] = useState(false);
    const [pipedriveId, setPipedriveId] = useState("");

    const connectLabel =
        language?.buttons?.connect_with_pipedrive ?? "Connect with Pipedrive";

    const sendPipedriveData = async (data) => {
        let newData = {
            name: pipedriveName,
            state: data?.state,
            code: data?.code,
            usage_types: [4],
        };
        let response = await sendDataPipedrive(newData);
        if (response.status) {
            setPipedriveCheck(true);
            setPipedriveBtn(false);
            if (props.selectFileSourceId) {
                props.selectFileSourceId(
                    response?.data?.source?.id,
                    response?.data?.source?.source_type_id,
                );
            }
            setPipedriveId(response?.data?.source?.id);
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
        }
    };

    const handlePipedriveName = (e) => {
        const inputValue = e.target.value;
        setPipedriveName(inputValue);
        setPipedriveBtn(inputValue !== "" && inputValue !== null);
    };

    const saveCrmMapping = (response) => {
        if (props?.setLoading !== undefined) {
            props?.setLoading(true);
        }
        if (response.status) {
            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: response.message && response.message,
                icon: "success",
                timer: 3000,
            });
            setPipedriveBtn(false);
            setPipedriveName("");
            setPipedriveId("");
            setPipedriveCheck(false);
            if (props.handleGetSources) {
                props.handleGetSources();
            }
            if (props.getAllSourcesReduxProps) {
                props.getAllSourcesReduxProps();
            }
            if (props.getTracker) {
                props.addToTracker(pipedriveId);
            }
            if (props.setNextCheck) {
                props.setNextCheck(true);
            }
            props?.handleClose(pipedriveId);
            if (props?.setLoading !== undefined) {
                props?.setLoading(false);
            }
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
            if (props?.setLoading !== undefined) {
                props?.setLoading(false);
            }
        }
    };

    return (
        <div>
            {pipedriveCheck ? (
                <>
                    <CrmSourceMappingArea
                        sourceId={pipedriveId}
                        sourceType={"pipe"}
                        mappingSuccess={saveCrmMapping}
                        isModal={props?.isModal}
                        hideSaveButton={useHostFooter}
                        registerFooterAction={registerFooterAction}
                    ></CrmSourceMappingArea>
                </>
            ) : (
                <>
                    <FormControl className="mb-3" style={{ width: "100%" }}>
                        <TextField
                            name="name"
                            label={language?.source_modal?.name ?? "Name"}
                            variant="outlined"
                            onChange={handlePipedriveName}
                            placeholder={
                                language?.source_modal?.please_write_name ??
                                "Please Write Name"
                            }
                            value={pipedriveName}
                            required
                        />
                    </FormControl>
                    <div className="position-relative overflow-hidden z-1">
                        {props.isButtonLoader !== undefined &&
                            props.isButtonLoader && (
                                <div className="circle-loader">
                                    <ClipLoader color={"#000"} size={17} />
                                </div>
                            )}
                        <LoginButton
                            getAuthUrl={getPipedriveUrl}
                            getAuthUrlResponseTransform={(response) => {
                                return response?.data?.url;
                            }}
                            code="pipedrive"
                            paramNames={["code", "state"]}
                            onSuccess={sendPipedriveData}
                            dataTransform={(params) => ({
                                code: params.code,
                                state: params.state,
                            })}
                            onLoadingChange={props?.setIsButtonLoader}
                            logoSrc={PIPEDRIVE_LOGO}
                            buttonText={connectLabel}
                            disabled={!pipedriveBtn}
                            isLoadingExternal={props?.isButtonLoader}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default PipedriveSource;
